<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="1200px"
      scrollable
      height="500px"
      @keydown="executeCloseModalFilesGoogleDrive"
      @click:outside="executeCloseModalFilesGoogleDrive"
    >
      <v-card>
        <section class="d-flex justify-space-between align-items-center p-4">
          <div class="pb-0 border border-bottom">
            <h5>Cargar Documentos desde Google Drive</h5>
          </div>
        </section>
        <v-card-text>
          <section class="text-center" v-if="loading || loadingDownload">
            <h5 class="mt-5">
              Cargando {{ loadingDownload ? "Archivo" : "Documentos" }}...
            </h5>
            <v-progress-circular
              indeterminate
              color="primary"
              class="mb-0 mt-5"
              size="80"
            ></v-progress-circular>
          </section>

          <!-- <v-container class="">
            <v-row align-content="center" justify="start" class="">
              <v-col cols="12" md="4" sm="12" class="mt-1 pb-0">
                <v-text-field
                  v-model="filters.search"
                  outlined
                  clearable
                  @input="getFilesFromGoogleDrive(null)"
                  placeholder="Buscar..."
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12" class="mt-1 pb-0">
                <v-autocomplete
                  v-model="filters.type"
                  :items="typesFiles"
                  item-text="text"
                  item-value="value"
                  single-line
                  hide-details
                  clearable
                  no-data-text="Sin Tipos disponibles"
                  @input="getFilesFromGoogleDrive(null)"
                  placeholder="Filtrar por Tipo"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          small
                          left
                          v-text="data.item.icon"
                          :color="data.item.color"
                        ></v-icon>
                        {{ data.item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-breadcrumbs
              class="p-0 mb-8 mt-2"
              :items="listFolders"
              v-if="listFolders.length"
            >
              <template v-slot:divider>
                <v-icon class="">mdi-play</v-icon>
              </template>
              <template v-slot:item="{ item, index }">
                <h5
                  @click="getFilesFolder(item)"
                  :class="{
                    'font-weight-bold': index == listFolders.length - 1,
                  }"
                  class="my-0 text-primary pointer"
                >
                  {{ item.name }}
                </h5>
              </template>
            </v-breadcrumbs>
            <h5
              v-if="!loading && currentFiles.length == 0"
              class="text-center mt-12"
            >
              No se encontraron resultados
            </h5>
            <section class="text-center" v-if="loading">
              <h5 class="mt-5">Cargando Documentos...</h5>
              <v-progress-circular
                indeterminate
                color="primary"
                class="mb-0 mt-5"
                size="80"
              ></v-progress-circular>
            </section>

            <div
              v-if="loadingDownload"
              class="text-center d-flex align-items-center mb-3"
            >
              <v-progress-circular
                indeterminate
                color="primary"
                class="mb-0"
                size="20"
              ></v-progress-circular>
              <small class="mx-2">Cargando Documento...</small>
            </div>
            <v-row align-content="center" justify="start" v-if="!loading">
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="4"
                class="pt-1"
                v-for="file in currentFiles"
                :key="file.id"
              >
                <v-card
                  :style="`background-color: ${
                    file.mimeType == folderMimeType ? '#e8e8e8' : '#f5f5f5'
                  }`"
                  elevation="2"
                  min-height="100"
                  class="pointer"
                  @click="
                    file.mimeType == folderMimeType
                      ? getFilesFolder(file)
                      : downloadFile(file)
                  "
                >
                  <section class="p-3 pb-0 d-flex align-items-center">
                    <img
                      class=""
                      :src="file.iconLink"
                      min-width="20"
                      max-width="20"
                      :alt="file.name"
                    />
                    <h5 class="mx-3 mt-2 font-weight-bold">{{ file.name }}</h5>
                  </section>
                </v-card>
              </v-col>
            </v-row>
          </v-container> -->
        </v-card-text>
        <v-card-actions>
          <!-- Resultados encontrados: {{ currentFiles.length }} -->
          <v-spacer></v-spacer>
          <!-- <v-btn
            outlined
            color="primary"
            v-if="nextPageToken"
            @click="getFilesFromGoogleDrive(nextPageToken)"
          >
            Cargar más resultados
          </v-btn> -->

          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalFilesGoogleDrive"
          >
            <small> Cancelar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { googleDriveService } from "@/services/google_drive_service";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalFilesGoogleDrive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      folderMimeType: "application/vnd.google-apps.folder",
      access_token_google_drive: null,
      filters: {
        type: null,
        search: "",
        pageSize: 9,
      },
      typesFiles: [
        {
          text: "Todos los tipos",
          value: null,
        },
        {
          text: "Carpetas",
          value: "application/vnd.google-apps.folder",
          icon: "mdi-folder",
        },
        {
          text: "Documentos",
          value: "application/vnd.google-apps.document",
          icon: "mdi-file-word",
          color: "primary",
        },
        {
          text: "Hojas de cálculo",
          value: "application/vnd.google-apps.spreadsheet",
          icon: "mdi-file-excel",
          color: "green",
        },
        {
          text: "PDF",
          value: "application/pdf",
          icon: "mdi-file-pdf",
          color: "red",
        },
        {
          text: "Imágenes y Fotos",
          value: "image",
          icon: "mdi-image",
          color: "red",
        },
        {
          text: "Archivos (ZIP)",
          value: "application/zip",
          icon: "mdi-folder-zip",
          color: "yellow darken-2",
        },
        {
          text: "Presentaciones",
          value: "application/vnd.google-apps.presentation",
          icon: "mdi-file-powerpoint",
          color: "orange",
        },
        {
          text: "Videos",
          value: "video",
          icon: "mdi-file-video",
          color: "blue",
        },
      ],
      // El mapa es mime type de google : mimeType
      mapExportFiles: {
        "application/vnd.google-apps.spreadsheet": [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          ".xlsx",
        ],
        "application/vnd.google-apps.document": [
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ".docx",
        ],
        "application/vnd.google-apps.presentation": [
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          ".pptx",
        ],
      },
      loading: false,
      loadingDownload: false,
      debounce: null,
      debounceTime: 500,
      currentFiles: [],
      nextPageToken: null,
      currentFolder: null,
      listFolders: [],
    };
  },
  methods: {
    async verifyAndGetGoogleDriveAccessToken() {
      this.loading = true;
      const access_token = localStorage.getItem("access_token_google_drive");
      if (access_token) {
        const resp = await googleDriveService.validateAccessToken(access_token);
        if (resp.status == 400) {
          return this.openModalLoginGoogle();
        }
        this.access_token_google_drive = access_token;
        this.loadPicker();
      } else {
        await this.openModalLoginGoogle();
      }
    },
    async getFilesFromGoogleDrive(nextPageToken = null) {
      let self = this;
      clearTimeout(this.debounce);
      let query = self.currentFolder
        ? `('${self.currentFolder.id}' in parents) and (trashed = false)`
        : "(trashed = false)";

      query = self.filters.search
        ? query +
          ` and (fullText contains '${self.filters.search}' or name contains '${self.filters.search}')`
        : query;

      query =
        self.filters.type && self.filters.search
          ? query + ` and (mimeType = '${self.filters.type}')`
          : self.filters.type
          ? query + ` and (mimeType contains "${self.filters.type}")`
          : query;

      self.debounce = await setTimeout(async function() {
        self.loading = true;
        if (nextPageToken) {
          self.filters.pageSize = self.filters.pageSize + 9;
        } else {
          self.filters.pageSize = 9;
        }

        const resp = await googleDriveService.getFilesFromDrive(
          self.access_token_google_drive,
          {
            q: query,
            pageSize: self.filters.pageSize,
          }
        );
        if (resp.status == 200) {
          self.loading = false;
          let responseData = await resp.json();
          self.currentFiles = responseData.files;
          self.nextPageToken = responseData.nextPageToken;
        }
        if (resp.status == 401) {
          self.openModalLoginGoogle();
        }
      }, self.debounceTime);
    },
    async openModalLoginGoogle() {
      let self = this;
      setTimeout(() => {
        this.$auth
          .authenticate("google")
          .then(async (response) => {
            const resp = await googleDriveService.getAccessToken(response.code);
            if (resp.status == 200) {
              const responseToken = await resp.json();
              localStorage.setItem(
                "access_token_google_drive",
                responseToken.access_token
              );
              self.$emit("accessTokenGoogleDrive", responseToken.access_token);
              localStorage.setItem(
                "refresh_token_google_drive",
                responseToken.refresh_token
              );
              self.access_token_google_drive = responseToken.access_token;
              self.loadPicker();
              // self.getFilesFromGoogleDrive();
            }
          })
          .catch((error) => {
            self.loading = false;
            if (error.status === 401) {
              self.$swal.fire({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error, verifique el correo y la contraseña sean correctos y que el dominio sea @fluxsolar.cl o @copecflux.cl",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              self.$swal.fire({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error, verifique el correo y la contraseña",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
              });
            }
            self.resetModal();
            self.closeModalFilesGoogleDrive(false);
          });
      }, 1000);
    },
    async getFilesFolder(folder) {
      this.filters = {
        search: "",
        type: "",
        pageSize: 9,
      };
      if (!folder.mimeType) {
        this.listFolders = [];
        this.currentFolder = null;
      } else {
        this.currentFolder = folder;
        this.syncListBreadcrumsFolder(folder);
      }
      await this.getFilesFromGoogleDrive();
    },
    //Función que verifica que si el folder existe en el listado, elimina todos los posteriores, si no existe, lo agrega
    async syncListBreadcrumsFolder(folder) {
      let self = this;
      if (self.listFolders.length == 0) {
        self.listFolders.push({
          name: "Inicio",
          mimeType: null,
        });
      }
      if (folder.id) {
        let index = self.listFolders.findIndex((item) => item.id == folder.id);
        if (index > -1) {
          self.listFolders = self.listFolders.slice(0, index + 1);
        } else {
          self.listFolders.push(folder);
        }
      }
    },
    async downloadFile(file) {
      try {
        this.loadingDownload = true;
        const response =
          file.mimeType == this.typesFiles[4].value ||
          !file.mimeType.includes("application") ||
          file.name.includes("xlsx")
            ? await googleDriveService.getFileFromId(
                this.access_token_google_drive,
                file.id
              )
            : await googleDriveService.exportFileFromId(
                this.access_token_google_drive,
                file.id,
                this.mapExportFiles[file.mimeType][0]
              );
        const blob = await response.blob();
        const fileDownload = new File(
          [blob],
          file.mimeType == this.typesFiles[4].value ||
          !file.mimeType.includes("application") ||
          file.name.includes("xlsx")
            ? file.name
            : file.name + this.mapExportFiles[file.mimeType][1],
          { type: blob.type }
        );
        this.$emit("fileDownload", fileDownload);
        this.loadingDownload = false;
        this.resetModal();
        this.closeModalFilesGoogleDrive();
      } catch (error) {
        if (error) {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: error && error.message ? error.message : error,
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      }
    },
    executeCloseModalFilesGoogleDrive($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.resetModal();
        this.closeModalFilesGoogleDrive($event);
      }
    },
    resetModal() {
      this.currentFiles = [];
      this.drives = [];
      this.filters = {
        search: "",
        type: "",
        pageSize: 9,
      };
      this.currentFolder = null;
      this.listFolders = [];
    },
    loadPicker() {
      let self = this;
      try {
        gapi.load("picker", () => {
          const picker = new google.picker.PickerBuilder()
            .addView(google.picker.ViewId.RECENTLY_PICKED)
            .addView(
              new google.picker.DocsView()
                .setIncludeFolders(true)
                .setOwnedByMe(true)
            )
            .addView(
              new google.picker.DocsView()
                .setIncludeFolders(true)
                .setOwnedByMe(false)
            )
            .addView(
              new google.picker.DocsView()
                .setIncludeFolders(true)
                .setSelectFolderEnabled(true)
                .setEnableDrives(true)
            )
            .enableFeature(google.picker.Feature.SUPPORT_DRIVES)
            .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
            .setOAuthToken(self.access_token_google_drive)
            .setDeveloperKey(process.env.VUE_APP_GOOGLE_API_KEY)
            .setCallback(self.onFilePicked)
            .setLocale("es")
            .build();
          picker.setVisible(true);
        });
      } catch (error) {
        console.log(error);
      }
    },
    onFilePicked(data) {
      if (data.action === google.picker.Action.PICKED) {
        this.loading = false;
        this.loadingDownload = true;
        const file = data.docs[0];
        this.downloadFile(file);
      } else if (data.action === google.picker.Action.CANCEL) {
        this.resetModal();
        this.closeModalFilesGoogleDrive();
      }
    },
  },
};
</script>

<style></style>
